export function getUserName(firstName: string, lastName: string) {
    return `${firstName} ${lastName}`;
}

export function getGenderFromPESEL(pesel: string) {
    const genderDigit = parseInt(pesel.slice(9, 10));
    if (genderDigit % 2) return 'man';
    return 'woman';
}
